import React from 'react';
import styles from './WaitingRoom.module.css';

interface WaitingRoomProps {
  roomCode: string;
  playerColor: string;
  opponent: any;
}

export const WaitingRoom: React.FC<WaitingRoomProps> = ({ roomCode, playerColor, opponent }) => {
  return (
    <div className={styles.waitingRoom}>
      <h2>Room Code: {roomCode}</h2>
      <div className={styles.playerInfo}>
        <p>You are playing as: <strong>{playerColor}</strong></p>
      </div>
      
      {!opponent ? (
        <div className={styles.waiting}>
          <div className={styles.spinner}></div>
          <p>Waiting for opponent to join...</p>
          <p className={styles.hint}>Share this room code with your friend: <strong>{roomCode}</strong></p>
        </div>
      ) : (
        <div className={styles.ready}>
          <p>Opponent joined: <strong>{opponent.name}</strong></p>
          <p>Game will start automatically...</p>
        </div>
      )}
    </div>
  );
};